'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	first: _propTypes2.default.bool,
	children: _propTypes2.default.node.isRequired,
	right: _propTypes2.default.bool,
	style: _propTypes2.default.object
};

var WMTableCell = function WMTableCell(props) {
	return _react2.default.createElement(
		'div',
		{
			style: Object.assign({}, (0, _styles2.default)(props), props.style)
		},
		props.children
	);
};

exports.default = (0, _radium2.default)(WMTableCell);


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableCell/index.js